import Toolbar from '@mui/material/Toolbar'
;('use no memo')
import { Table } from '@tanstack/react-table'
import React from 'react'
import GlobalFilter from './GlobalFilter'
import Grid from '@mui/material/Grid2'
import VisibilityControls from './VisibilityControls'

interface TableToolbarProps {
  search?: boolean
  preGlobalFilteredRowsCount?: number
  setGlobalFilter?: (value: string) => void
  globalFilter?: string
  toolbarControls?: React.ReactNode
  table: Table<any>
  newStyle?: boolean
}

/**
 * Table toolbar component.
 *
 * @param search - Should search field be shown.
 * @param preGlobalFilteredRowsCount - Number of rows before filtering.
 * @param setGlobalFilter - Function to set global filter.
 * @param globalFilter - Global filter value.
 * @param toolbarControls - Toolbar controls.
 * @param table - Table instance.
 * @param newStyle - New style.
 * @returns Table toolbar.
 * @notExported
 */
const TableToolbar = ({
  search,
  preGlobalFilteredRowsCount,
  setGlobalFilter,
  globalFilter,
  toolbarControls,
  table,
  newStyle,
}: TableToolbarProps) => {
  return (
    <Toolbar disableGutters={newStyle ? true : false}>
      <Grid container size={12} alignItems="center">
        {search && (
          <Grid
            size={{
              xs: 12,
              md: 7,
            }}
          >
            <GlobalFilter
              rowCount={preGlobalFilteredRowsCount}
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
              newStyle={newStyle}
            />
          </Grid>
        )}
        <Grid container justifyContent="flex-end" alignContent="center" size="grow">
          {toolbarControls}
        </Grid>
        <Grid container justifyContent="flex-end" alignContent="center" size="grow">
          <VisibilityControls table={table} />
        </Grid>
      </Grid>
    </Toolbar>
  )
}

export default TableToolbar
